import { useEffect, useState, useContext } from 'react';
import { pushGaData } from '../utils';
import { DiilHeaderContext } from './DiilHeader';
import { getBaseSelfServiceUrl, getMainpageUrl, getPublicApiUrl } from './EnvironmentUrls';
import { fetchJson } from './JSONController';
import { suffixLangIfNeeded, prefixLangIfNeeded } from './NavigationHelper';
const pushEnvItemGaData = (eventLabel) => {
    pushGaData({ eventAction: 'Choose segment', eventLabel });
};
const NavItemsProvider = (props) => {
    const { navigate, isOnPath, environment, app, languageProps, apiBaseUrl, initialMenuItems, onChange, brand, translate, location } = useContext(DiilHeaderContext);
    const [navItems, setNavItems] = useState([]);
    const [appMenus, setAppMenus] = useState(new Map());
    const [segmentItems, setSegmentItems] = useState(null);
    const [initialLanguage] = useState(languageProps.currentLanguage);
    useEffect(() => {
        initializeNavItems();
    }, []);
    useEffect(() => {
        initializeNavItems();
        setSegmentItems(getSegmentItems());
    }, [languageProps.currentLanguage]);
    useEffect(() => {
        handlePathNameChange();
        setSegmentItems(getSegmentItems());
    }, [translate, location]);
    const label = () => {
        var _a;
        return (_a = appMenus.get(languageProps.currentLanguage)) === null || _a === void 0 ? void 0 : _a.label;
    };
    const initializeNavItems = async () => {
        if ((initialMenuItems === null || initialMenuItems === void 0 ? void 0 : initialMenuItems.items) && initialLanguage === languageProps.currentLanguage) {
            setAppMenu(initialMenuItems);
            setNavItems(createNavTree(initialMenuItems.items));
            return;
        }
        const menus = appMenus.get(languageProps.currentLanguage);
        let menuItems = menus === null || menus === void 0 ? void 0 : menus.items;
        if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) {
            menuItems = (await fetchNavItems()).items;
        }
        else {
            callChangeCallback(menus);
        }
        setNavItems(createNavTree(menuItems));
    };
    const fetchNavItems = async () => {
        let url = `${getPublicApiUrl(environment, brand)}/menu/header/${languageProps.currentLanguage}/code/${getMenuCode()}?app=${brand}`;
        if (apiBaseUrl) {
            url = `${apiBaseUrl}/menu/header/${languageProps.currentLanguage}/code/${getMenuCode()}?app=${brand}`;
        }
        try {
            const response = await fetchJson(url);
            callChangeCallback(response);
            setAppMenu(response);
            return response;
        }
        catch (e) {
            console.error(e);
            return Promise.reject('Error during menu items fetch');
        }
    };
    const handlePathNameChange = () => {
        var _a;
        const menuItems = (_a = appMenus.get(languageProps.currentLanguage)) === null || _a === void 0 ? void 0 : _a.items;
        setNavItems(createNavTree(menuItems));
    };
    const setAppMenu = (menu) => {
        callChangeCallback(menu);
        setAppMenus((prev) => {
            prev.set(languageProps.currentLanguage, menu);
            return prev;
        });
    };
    const callChangeCallback = (menu) => {
        if (typeof onChange === 'function') {
            onChange(menu);
        }
    };
    const getSegmentItems = () => {
        if (brand === 'super') {
            return undefined;
        }
        return {
            items: [
                {
                    label: translate('header.nav.homepage'),
                    url: app === 'public' ? '/' : suffixLangIfNeeded(getMainpageUrl(environment, brand), languageProps.currentLanguage),
                    current: app === 'public',
                    onClick: (event) => {
                        pushEnvItemGaData('Koduleht');
                        navigate(event);
                    }
                },
                {
                    label: translate('header.nav.selfService'),
                    url: app === 'selfservice'
                        ? '/'
                        : suffixLangIfNeeded(getBaseSelfServiceUrl(environment, brand, languageProps.currentLanguage), languageProps.currentLanguage),
                    current: app === 'selfservice',
                    onClick: (event) => {
                        pushEnvItemGaData('Iseteenindus');
                        navigate(event);
                    }
                }
            ]
        };
    };
    const getMenuCode = () => {
        switch (app) {
            case 'selfservice':
                return 'SELFSERVICE_MENU';
            case 'public':
            default:
                return 'MAIN_MENU';
        }
    };
    const createNavTree = (menuItems) => {
        let navTree = [];
        if (menuItems) {
            navTree = menuItems.map((item) => mapItemForNavTree(item));
        }
        return navTree;
    };
    const mapItemForNavTree = (item) => {
        var _a;
        const url = prefixLangIfNeeded(item.path, languageProps.currentLanguage);
        return {
            id: (_a = item.id) === null || _a === void 0 ? void 0 : _a.toString(),
            label: item.label,
            isCurrent: isOnPath(url),
            url,
            onClick: (event) => {
                pushGaData({ eventAction: 'Header Menu Item', eventLabel: item.label });
                props.setSection(null);
                navigate(event);
            }
        };
    };
    return { segmentItems, navItems, label };
};
export default NavItemsProvider;
//# sourceMappingURL=NavItemsProvider.js.map